import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Wrench, Search } from "lucide-react";

export default function PartsPage() {
  const [products, setProducts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [q, setQ] = useState("");

  useEffect(() => {
    document.title = "Piese trotinete electrice — livrare gratuită | Troti-X Timișoara";
    api.get("/shop/products").then((r) => {
      setProducts(r.data.filter((p) => p.category === "piesa" || p.category === "accesoriu"));
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const filtered = products.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="parts-page" className="max-w-7xl mx-auto px-6 py-14">
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Piese & accesorii</div>
      <h1 className="font-display text-4xl sm:text-5xl uppercase">Piese <span className="text-[#00E5FF]">trotinete</span></h1>
      <p className="text-neutral-500 text-sm mt-3 max-w-xl">Piese și accesorii testate în atelierul nostru — camere, anvelope, frâne, încărcătoare și tot ce-ți trebuie. Nu găsești ce cauți? Sună-ne: 0743 110 277.</p>

      <div className="relative mt-8 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-500" />
        <input data-testid="parts-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cauta piesa..."
          className="w-full bg-[#0B0B0B] border border-[#00E5FF]/25 focus:border-[#00E5FF] pl-9 pr-4 py-3 text-sm" />
      </div>

      {loaded && filtered.length === 0 ? (
        <div className="border border-dashed border-[#00E5FF]/20 p-20 text-center text-neutral-500 mt-10">
          <Wrench className="w-12 h-12 mx-auto mb-4 text-[#00E5FF]/30" />
          {q ? "Nicio piesa gasita pentru cautarea ta." : "Piesele sosesc in curand. Suna-ne pentru orice piesa: 0743 110 277."}
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mt-10">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
